export const constant: any = {
  URL: "https://www.biu.ac.il",
  API_BASE_URL: "https://www.biu.ac.il/",
  API_STAGE_URL: "https://develop-sr3snxi-xczzslk5utglk.eu-4.platformsh.site",
  EVENTS_BASE_PATH: "jsonapi/index/biu_events",
  INCLUDES: `?include=field_contact_data,field_interest_domains,field_organizing_unit,field_featured_media_image.field_media_image,field_event_program&page[offset]=0&page[limit]=15&filter[status]=1&filter[cond_1][group][conjunction]=AND&filter[cond_2][group][conjunction]=AND&filter[cond_all][group][conjunction]=OR&filter[cond_1][group][memberOf]=cond_all&filter[cond_2][group][memberOf]=cond_all`,
  EVENTS_MEDIA: '/jsonapi/media/image?filter%5Bid%5D',
  EVENTS_MEDIA_VIDEO: '/jsonapi/media/remote_video?filter[id]',
  EVENTS_CULC_UNITS_PATH: "/jsonapi/taxonomy_term/calculated_units?filter[field_domain_name]",
  DEV: "development",
  PROD: "production",
  SOCIAL_LINKS: {
    facebook:
      "https://www.facebook.com/sharer/sharer.php?u=",
    twitter: "https://twitter.com/intent/tweet?url=",
    mail: "mailto:?subject=I wanted you to see this Event&amp;body=Check out this site",
  }, 
  HE: {
    VARIABLES: {
      EMAIL: 'דוא"ל',
      CONTACT: "יצירת קשר",
      ENTER_EVENT: "לכניסה לאירוע",
      COMBINED_EVENT: "אירוע משולב",
      EVENT_LINK: "לינק לאירוע",
      EVENT_DATES: "תאריך האירוע",
      EVENT_TIME: "שעת האירוע",
      EVENT_LOCATION: "מיקום האירוע",
      EVENT_COST: "מחיר האירוע",
      EVENT_AUDIENCE: "קהל יעד",
      EVENT_TYPE: "סוג האירוע",
      ENROLLMENT: "לכניסה לאירוע",
      REGISTRATION_ONLY: "הרשמה",
      REGISTRATION_AND_PAYMENT: "הרשמה ותשלום",
      SHARE_WITH: "שתפו עם חברים",
      PAST_EVENTS: "אירועי עבר",
      PROGRAM: "תוכנייה",
      LOAD_MORE: "הצג עוד",
      NO_RESULT: "אין תוצאות",
      NO_COST: "ללא עלות",
      EVENTS: "אירועים",
      ONLINE_EVENT: "אירוע מקוון",
      PHYSICAL_EVENT: "אירוע פיזי",
      DOWNLOAD_TO_CAL: "הורידו ליומן",
      CALENDAR_LABEL: "מועד אחר",
      THIS_MONTH: "החודש",
      THIS_WEEK: "השבוע",
      RESET: "איפוס",
      LOADING: "טוען",
      SEARCH: "חיפוש",
      TO_PAST: "לארכיון אירועים",
      TO_ACTIVE: "ללוח אירועים",
      ACTIVATION_STATUS:'מלגות פעילות',
      AN_ONLINE_EVENT: "אירוע מקוון",
      CALENDAR_DAY_HEADERS: ["שבת", "ו", "ה", "ד", "ג", "ב", "א"],
      CALENDAR_MONTHS: [
        "ינואר",
        "פברואר",
        "מרץ",
        "אפריל",
        "מאי",
        "יוני",
        "יולי",
        "אוגוסט",
        "ספטמבר",
        "אוקטובר",
        "נובמבר",
        "דצמבר",
      ],
      DAYS_IN_WEEK: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
      DOWNLOAD_OPTION: [
        { id: "icalendar", value: "iCalendar" },
        { id: "googleCalendar", value: "Google Calendar" },
        { id: "outlook", value: "Outlook" },
      ],
      AUDIENCE: {
        wide_audience: "הקהל הרחב",
        invited_only: "מוזמנים בלבד",
        students: "מיועד לסטודנטים",
        alumni: "מיועד לבוגרי בר-אילן",
        staff: "מיועד לסגל בר-אילן",
        children: "מיועד לילדים ונוער",
        registration_required: "פתוח בהרשמה מראש",
      },
      PAID: 'ש"ח',
      FREE: "ללא עלות",
      FILTER_FREE: "ללא תשלום",
      DEFAULT_EVENT_TYPE: {
        id: "event_type",
        label: "סוג אירוע",
        value: null,
      },
      DEFAULT_ORGANIZING_UNIT: {
        id: "organizing_unit",
        label: "גורם מארגן",
        value: null,
      },
      DEFAULT_INTERESTED_DOMAIN: {
        id: "event_interest_domains",
        label: "תחומי עניין",
        value: null,
      },
    },
  },
  EN: {
    VARIABLES: {
      EMAIL: "email",
      CONTACT: "Contact",
      ENTER_EVENT: "Join the event",
      COMBINED_EVENT: "Hybrid event",
      EVENT_LINK: "Link",
      EVENT_DATES: "Date",
      EVENT_TIME: "Time",
      EVENT_LOCATION: "Location",
      EVENT_COST: "Price",
      EVENT_TYPE: "Type",
      EVENT_AUDIENCE: "Audience",
      ENROLLMENT: "Enrollment",
      REGISTRATION_ONLY: "Register",
      REGISTRATION_AND_PAYMENT: "Register & Pay",
      SHARE_WITH: "Share with friends",
      PAST_EVENTS: "Past Events",
      LOAD_MORE: "Load More",
      PROGRAM: "Program",
      NO_RESULT: "No Results",
      EVENTS: "Events",
      ONLINE_EVENT: "Virtual event",
      PHYSICAL_EVENT: "Physical event",
      DOWNLOAD_TO_CAL: "Save to Calendar",
      CALENDAR_LABEL: "Another Date",
      THIS_MONTH: "This Month",
      THIS_WEEK: "This Week",
      NO_COST: "Free admission",
      RESET: "Reset",
      LOADING: "Loading",
      TO_PAST: "To events archive",
      TO_ACTIVE: "To events lobby",
      SEARCH: "Search",
      ACTIVATION_STATUS:'Activation Status',
      AN_ONLINE_EVENT: "An online event",
      CALENDAR_DAY_HEADERS: ["S", "M", "T", "W", "T", "F", "S"],
      CALENDAR_MONTHS: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      DAYS_IN_WEEK: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      DOWNLOAD_OPTION: [
        { id: "icalendar", value: "iCalendar" },
        { id: "googleCalendar", value: "Google Calendar" },
        { id: "outlook", value: "Outlook" },
      ],
      AUDIENCE: {
        wide_audience: "Open to the public",
        invited_only: "Invited only",
        students: "Students",
        alumni: "Graduates",
        staff: "Faculty & Staff",
        children: "Children & Youth",
        registration_required: "Registration Required",
      },
      PAID: "NIS",
      FREE: "Free admission",
      FILTER_FREE: "Free",
      DEFAULT_EVENT_TYPE: {
        id: "event_type",
        label: "Event Type",
        value: null,
      },
      DEFAULT_ORGANIZING_UNIT: {
        id: "organizing_unit",
        label: "Organizing Unit",
        value: null,
      },
      DEFAULT_INTERESTED_DOMAIN: {
        id: "event_interest_domains",
        label: "Interested Domain",
        value: null,
      },
    },
  },
  DRUPAL_FILTER_FIELDS: {
    search: "fulltext",
    eventCost: "field_event_cost",
    eventMode: "field_event_mode",
    eventType: "field_event_type",
    interestedDomain: "field_event_interest_domains",
    onlineEvent: "field_online_event",
    organizingUnit: "field_organizing_unit",
  },
  DRUPAL_FIELDS: {
    PHYSICAL_EVENT: "physical_event",
    COMBINED_EVENT: "combined_event",
    ONLINE_EVENT: "digital_event",
  },
  EN_WEEK_DAYS_REG_EX_PATTERNS: /(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday)/g,
};

export default constant;
